/**
 * FeaturedBook — promotes "The Deliberate Mind" on Amazon. Self-contained
 * card designed to drop into the home page or any collection page.
 */
const AMAZON_URL =
  "https://www.amazon.com/Deliberate-Mind-Morning-Afternoon-Reflection-ebook/dp/B0GZC54DW5";
const AMAZON_SAMPLE_URL =
  "https://read.amazon.com/sample/B0GZC54DW5";

export function FeaturedBook() {
  return (
    <section aria-labelledby="featured-book-heading" className="border-t border-border/60 bg-ink/40">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:py-20">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-center">
          {/* Book cover mock — pure CSS, no external assets */}
          <div className="relative mx-auto w-full max-w-sm">
            <a
              href={AMAZON_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="The Deliberate Mind on Amazon"
              className="group block"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden shadow-elegant border border-gold/20 bg-gradient-to-br from-[#1a2244] via-[#0b1226] to-[#070d1d] transition-transform group-hover:-translate-y-1 group-hover:shadow-gold">
                <div className="absolute inset-0 opacity-30 mix-blend-screen" aria-hidden>
                  <div className="absolute -top-20 -right-20 h-56 w-56 rounded-full bg-gold/40 blur-3xl" />
                </div>
                <div className="absolute inset-0 flex flex-col items-center justify-center px-8 text-center">
                  <div className="text-[9px] uppercase tracking-[0.4em] text-gold/80">Minister JEB</div>
                  <div className="mt-6 font-display text-3xl sm:text-4xl font-bold text-cream text-foreground leading-tight">
                    The Deliberate Mind
                  </div>
                  <div className="mt-4 h-px w-10 bg-gold/60" />
                  <div className="mt-4 text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                    365 Days of Morning, Afternoon, & Evening<br />Reflections
                  </div>
                </div>
                <div className="absolute bottom-3 left-0 right-0 text-center text-[9px] uppercase tracking-[0.3em] text-gold/60">
                  Mr. B Quotes
                </div>
              </div>
            </a>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Featured book</div>
            <h2 id="featured-book-heading" className="mt-2 font-display text-4xl sm:text-5xl">
              <span className="text-gold italic">The Deliberate Mind</span> — by Mr. B Quotes
            </h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              A guided collection of quotes for morning, afternoon, and evening reflections — short, deliberate readings to begin
              and steady your day. From the voice behind Mr. B Quotes, this companion book turns thoughtful
              quotes into a daily practice of attention, gratitude, and clear thinking.
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground/85">
              <li className="flex items-start gap-2"><span className="text-gold mt-1">✦</span>Three readings a day — morning intention, afternoon reset, and evening rest.</li>
              <li className="flex items-start gap-2"><span className="text-gold mt-1">✦</span>Paperback curated quotes from some of the greatest minds for physical reading and meditation.</li>
              <li className="flex items-start gap-2"><span className="text-gold mt-1">✦</span>Kindle eBook — read on phone, tablet, or e-reader.</li>
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#FF9900] px-5 py-3 text-sm font-semibold text-ink hover:opacity-90 transition"
              >
                <AmazonIcon /> Get it on Amazon
              </a>
              <a
                href={AMAZON_SAMPLE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-3 text-sm hover:border-gold transition"
              >
                Read the sample →
              </a>
            </div>
            <p className="mt-4 text-[11px] text-muted-foreground">
              Feel free to get your copy and share with someone.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function AmazonIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
      <path d="M15.6 14.4c-1.3 1-3.2 1.5-4.8 1.5-2.2 0-4.3-.8-5.9-2.2-.1-.1 0-.3.2-.2 1.7 1 3.8 1.6 6 1.6 1.5 0 3.1-.3 4.7-1 .2-.1.4.1.2.3zm.5-.6c-.1-.2-.9-.1-1.3-.1-.1 0-.1-.1-.1-.1 0-.1.1-.1.1-.2.8-.5 2-.4 2.1-.2.1.2-.2 1.4-.9 2-.1 0-.2 0-.1-.1.1-.4.4-1.2.2-1.3zM8 11.2V9.8h6.4c.1 0 .2.1.2.2v1.2c0 .1-.1.3-.3.5L11 14.8c.9 0 1.8.1 2.6.6.2.1.2.3.3.4v1.3c0 .1-.1.3-.3.2-1.5-.8-3.5-.9-5.2 0-.2.1-.3-.1-.3-.2v-1.2c0-.2 0-.4.1-.7l3.8-5.5H8.3c-.2 0-.3-.1-.3-.5z"/>
    </svg>
  );
}
